// Installation PWA : capture du prompt natif (Android/Chrome) et détection du mode d'affichage.
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((l) => l(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    try { localStorage.setItem("sanitdocs_pwa_installed", "1"); } catch (_) {}
    listeners.forEach((l) => l(false));
  });
}

export const isStandalone = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true);

export const isIOS = () =>
  typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

export const canPromptInstall = () => !!deferredPrompt;

export function onInstallAvailable(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  if (outcome === "accepted") deferredPrompt = null;
  return outcome; // "accepted" | "dismissed"
}

const JOIN_KEY = "sanitdocs_join";
export const saveJoin = (data) => { try { localStorage.setItem(JOIN_KEY, JSON.stringify({ ...data, saved_at: Date.now() })); } catch (_) {} };
export const loadJoin = () => { try { return JSON.parse(localStorage.getItem(JOIN_KEY) || "null"); } catch (_) { return null; } };
export const clearJoin = () => { try { localStorage.removeItem(JOIN_KEY); } catch (_) {} };

const NOTIF_KEY = "sanitdocs_notif_optin";
export const setNotifOptIn = (v) => { try { v ? localStorage.setItem(NOTIF_KEY, "1") : localStorage.removeItem(NOTIF_KEY); } catch (_) {} };
export const hasNotifOptIn = () => { try { return localStorage.getItem(NOTIF_KEY) === "1"; } catch (_) { return false; } };
